import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import apiClient from "#/redux/api/ApiClient";
import { getErrorMessage } from "#/utils/APIUtils.js";

const DOCUMENT_GENERATION_TIMEOUT_MS = 60 * 60 * 1000; // 1 hour

export const getDocumentPlaceholders = createAsyncThunk(
  "document/dialogPlaceholders",
  async (templateId, { rejectWithValue }) => {
    try {
      const response = await apiClient.get(
        `/api/docx/gen/docxgen/dialogplaceholders/${templateId}`
      );
      return { data: response.data, templateId };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

export const generateDocument = createAsyncThunk(
  "document/generate",
  async ({ templateId, dto, format = "DOCX" }, { rejectWithValue }) => {
    try {
      const response = await apiClient.post(
        `/api/docx/gen/docxgen/generate?templateId=${templateId}&format=${format}`,
        dto,
        {
          responseType: "blob",
          timeout: DOCUMENT_GENERATION_TIMEOUT_MS,
        }
      );
      const disposition = response.headers["content-disposition"];
      const filename =
        disposition?.match(/filename="(.+?)"/)?.[1] ?? "generated.docx";
      return {
        fileName: filename,
        data: response.data,
      };
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  }
);

const documentSlice = createSlice({
  name: "document",
  initialState: {
    documentPlaceholders: {
      isLoading: false,
      error: null,
      byTemplateId: {},
    },
    generate: {
      isLoading: false,
      error: null,
    },
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getDocumentPlaceholders.fulfilled, (state, action) => {
        state.documentPlaceholders.isLoading = false;
        state.documentPlaceholders.byTemplateId[action.payload.templateId] =
          action.payload.data;
      })
      .addCase(getDocumentPlaceholders.rejected, (state, action) => {
        state.documentPlaceholders.isLoading = false;
        state.documentPlaceholders.error = action.payload;
      })
      .addCase(getDocumentPlaceholders.pending, (state, _) => {
        state.documentPlaceholders.isLoading = true;
        state.documentPlaceholders.error = null;
      })

      .addCase(generateDocument.fulfilled, (state, _) => {
        state.generate.isLoading = false;
      })
      .addCase(generateDocument.rejected, (state, action) => {
        state.generate.isLoading = false;
        state.generate.error = action.payload;
      })
      .addCase(generateDocument.pending, (state, _) => {
        state.generate.isLoading = true;
      });
  },
});

export default documentSlice.reducer;
